import React from "react";
import { Table, Button } from "react-bootstrap";
import moment from "moment";
import ExportSendingModal from "../../modals/ExportSendingModal";

class MailingViewerTable extends React.Component {
  constructor() {
    super();

    this.state = {
      mailings: [],
      showExportSendingModal: false
    };

    this.openExportSendingModal = this.openExportSendingModal.bind(this);
    this.closeExportSendingModal = this.closeExportSendingModal.bind(this);
  }
  componentWillMount() {
    this.setState({
      mailings: this.props.video.mailings
    });
  }
  componentWillReceiveProps(props) {
    this.setState({
      mailings: props.video.mailings
    });
  }
  setStatusClass(status) {
    status = status || "";
    let parsedStatus = status.toLowerCase();
    let classes = {
      pronto: "text-success",
      aprovado: "text-success",
      "em análise": "text-warning",
      "gerando urls": "text-warning",
      rejeitado: "text-danger"
    };
    return classes[parsedStatus];
  }
  openExportSendingModal() {
    this.setState({
      showExportSendingModal: true
    });
  }
  closeExportSendingModal() {
    this.setState({
      showExportSendingModal: false
    });
  }
  render() {
    const { video } = this.props;
    return (
      <div>
        <Table striped bordered>
          <thead>
            <tr>
              <th class="col-md-2">Nome</th>
              <th class="col-md-2">Data de Envio</th>
              <th class="col-md-2">Status</th>
              <th class="col-md-3">Observações</th>
              <th class="col-md-1" />
            </tr>
          </thead>
          <tbody>
            {this.state.mailings.length > 0 ? (
              this.state.mailings.map((mailing, index) => (
                <tr key={index}>
                  <td>{mailing.name}</td>
                  <td>
                    {moment(mailing.created_at).format(
                      "DD/MM/YYYY [às] HH:mm:ss"
                    )}
                  </td>
                  <td>
                    <span className={this.setStatusClass(mailing.status)}>
                      {mailing.status}
                    </span>
                  </td>
                  <td>{mailing.rejection_motive}</td>
                  <td>
                    {mailing.status === "Pronto" && (
                      <Button
                        bsSize="xsmall"
                        bsStyle="link"
                        onClick={() => {
                          this.setState({ sendingId: mailing.sending_id });
                          this.openExportSendingModal();
                        }}
                      >
                        Baixar URLs
                      </Button>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={5}>Nenhum mailing enviado até o momento.</td>
              </tr>
            )}
          </tbody>
        </Table>
        <ExportSendingModal
          show={this.state.showExportSendingModal}
          close={this.closeExportSendingModal}
          sendingId={this.state.sendingId}
          video={video}
        />
      </div>
    );
  }
}

export default MailingViewerTable;



// WEBPACK FOOTER //
// ./src/components/pages/Mailing/MailingViewerTable.js